/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Doc_Uploaded_OnInputs */

const en_doc_uploaded_on = /** @type {(inputs: Doc_Uploaded_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uploaded on ${i?.date}`)
};

const pt_br2_doc_uploaded_on = /** @type {(inputs: Doc_Uploaded_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enviado em ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Uploaded on {date}" |
*
* @param {Doc_Uploaded_OnInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_uploaded_on = /** @type {((inputs: Doc_Uploaded_OnInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Uploaded_OnInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_uploaded_on(inputs)
	return pt_br2_doc_uploaded_on(inputs)
});